import React from "react";

export interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  icon?: React.ReactElement;
  iconClassName?: string;
}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, icon, iconClassName = '', ...props }, ref) => {
    return (
      <div className="relative flex items-center">
        {icon && (
          <span className={`absolute left-3 ${iconClassName}`}>
            {React.cloneElement(icon, { className: "h-5 w-5" })}
          </span>
        )}
        <input
          className={`w-full ${icon ? 'pl-10' : ''} ${className}`}
          ref={ref}
          {...props}
        />
      </div>
    )
  }
)

export default Input